import { Injectable } from '@angular/core';
import { WP_API_CURSOS_POS_GRADUACAO } from 'app/config';

export const URL_POSGRADUACAO = WP_API_CURSOS_POS_GRADUACAO + `/cursosposgraduacao/doutorado/`;
export const URL_POSGRADUACAO_FAMAZ = 'https://www.famaz.edu.br/famaz-wordpress/index.php//wp-json/wp/v2/cursosposgraduacao?per_page=20';

@Injectable()
export class PosMedService {

    constructor() { }

    async getCursosPosMedGraduacao() {
      const data = await fetch(URL_POSGRADUACAO_FAMAZ)
      const result = await data.json()
      const resultsFiltereds = result.filter(pos => pos.tipo === "pos-med")

      console.log(resultsFiltereds)
      return resultsFiltereds
    }

    async getCursosPosMedPerId(codigo: number) {
      const cursos = await fetch(URL_POSGRADUACAO_FAMAZ)
      const data = await cursos.json()

      const result = data.filter(curso => curso.codigo === codigo)

      return result
    }

    async getImage(path: string): Promise<string> {
      const data = await fetch(path)
      const result = await data.json()

      const href = result.guid.rendered

      return href
    }
}
